import { getDialCodeByIso } from './countryCodes'

/**
 * Format a phone number for display with country code dial code
 * @param phoneNumber - The phone number to format
 * @param phoneCountryCode - ISO country code (e.g., "US", "AU", "GB")
 * @returns Formatted phone string with dial code, or just the phone number if no country code
 */
export function formatPhoneDisplay(
  phoneNumber: string | undefined,
  phoneCountryCode: string | undefined
): string {
  // Return empty string if no phone number
  if (!phoneNumber || phoneNumber.trim() === '') {
    return ''
  }

  // If country code exists, look up dial code and prepend
  if (phoneCountryCode) {
    const dialCode = getDialCodeByIso(phoneCountryCode)
    if (dialCode) {
      return `${dialCode} ${phoneNumber}`
    }
  }

  // Return phone number as-is (backward compatibility for historical data)
  return phoneNumber
}
